@if (confirmDialogService.dialog(); as dialog) {
  <div
    class="confirm-dialog-backdrop"
    data-cy="confirm-dialog"
    role="presentation"
    (click)="cancel()"
  >
    <div
      class="confirm-dialog-panel"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'confirm-dialog-title'"
      (click)="$event.stopPropagation()"
    >
      <h2 id="confirm-dialog-title" class="confirm-dialog-title">{{ dialog.title }}</h2>
      <p class="confirm-dialog-message">{{ dialog.message }}</p>
      <div class="confirm-dialog-actions">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-cy="confirm-dialog-cancel"
          (click)="cancel()"
        >
          <i class="bi bi-x-lg me-1" aria-hidden="true"></i>{{ dialog.cancelLabel }}
        </button>
        <button
          type="button"
          class="btn"
          [class.btn-danger]="dialog.variant === 'danger'"
          [class.btn-primary]="dialog.variant === 'primary'"
          data-cy="confirm-dialog-accept"
          (click)="accept()"
        >
          <i class="bi" [class.bi-trash]="dialog.variant === 'danger'" [class.bi-check-lg]="dialog.variant !== 'danger'" aria-hidden="true"></i>
          <span class="ms-1">{{ dialog.confirmLabel }}</span>
        </button>
      </div>
    </div>
  </div>
}
